<template>
    <div>
        <nav class="input" style="width: 150px">
            <el-select v-model="type" placeholder="类型" size="medium">
                <el-option label="全部" :value="-1" />
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
        </nav>
        <nav class="input" style="width: 150px">
            <el-select v-model="business" placeholder="行业" size="medium" :disabled="!independentBusiness && form.type == ''">
                <el-option label="全部" :value="-1" />
                <el-option v-for="item in businessList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
        </nav>
        <nav class="input" style="width: 150px">
            <el-select v-model="subBusiness" placeholder="二级行业" :disabled="form.business == ''" size="medium">
                <el-option label="全部" :value="-1" />
                <el-option v-for="item in subBusinessList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
        </nav>
    </div>
</template>

<script>
import { fetchEnterpriseTypeList } from "@/utils/methods";

export default {
    props: {
        form: {
            type: Object,
            default() {
                return {
                
                };
            },
        },
        independentBusiness: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            typeList: [],
            businessList: [],
            subBusinessList: [],
        };
    },
    watch: {
        type(newValue, oldValue) {
            if (this.independentBusiness) {
                return;
            }
            this.businessList = [];
            this.subBusinessList = [];
            this.form.business = '';
            this.form.subBusiness = '';
            this.getType("1");
        },
        business(newValue, oldValue) {
            this.subBusinessList = [];
            this.form.subBusiness = '';
            if (newValue !== '' && newValue != null && newValue !== -1) {
                this.getType("2");
            }
        },
    },
    methods: {
        resetSubBusinessList() {
            this.subBusinessList = [];
            if (this.form) {
                this.form.subBusiness = '';
            }
        },
        async loadEnterpriseTypeList() {
            this.typeList = await fetchEnterpriseTypeList(this.$http);
        },
        async getType(val) {
            if (val == 1) {
                var { data: res } = await this.$http.get(
                    `/admin/EnterpriseCategory/getList?keyword=&page=1&pageSize=100&order=&businessId=`
                );
                this.businessList = res.data.list;
                return;
            }
            if (val == 2) {
                var { data: res } = await this.$http.get(
                    `/admin/EnterpriseCategory/getList?keyword=&page=1&pageSize=100&order=&businessId=${this.business || ''}`
                );
                this.subBusinessList = res.data.list;
                return;
            }
            await this.loadEnterpriseTypeList();
            if (this.independentBusiness) {
                await this.getType("1");
            }
        },
    },
    computed: {
        type: {
            get() {
                return this.form.type;
            },
            set(type) {
                this.$emit("update:form", { ...this.form, type });
            },
        },
        business: {
            get() {
                return this.form.business;
            },
            set(business) {
                this.$emit("update:form", { ...this.form, business });
            },
        },
        subBusiness: {
            get() {
                return this.form.subBusiness;
            },
            set(subBusiness) {
                this.$emit("update:form", { ...this.form, subBusiness });
            },
        },
    },
    mounted() {
        this.getType();
    },
};
</script>

<style lang="scss" scoped></style>
